module.exports = __webpack_public_path__ + "static/media/Deer_5_t.4f68d650.jpg";